/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { IBadge } from './badge.interface';

@Component({
	selector: 'engage-badge',
	templateUrl: './badge.component.html',
	styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {
	@Input() data: IBadge[];

	public badgeClasses = '';
	public boxShadow = 'no-box-shadow';
	public withBackground = 'no-background';
	ngOnInit() {
		// add box shadow class if true and background color specified
		// check for 'false' string accounts for api's inconsistently returning booleans and strings values.
		if (this.data[0].badgeBoxShadow) {
			this.boxShadow = this.data[0].backgroundColor ? 'box-shadow' : 'no-box-shadow';
		}
		this.withBackground = this.data[0].backgroundColor ? 'with-background' : 'no-background';
		this.badgeClasses = `${this.boxShadow} ${this.withBackground}`;
	}

	trackByBgColor(index: number, item: IBadge): string {
		return index.toString() + item.backgroundColor;
	}
}
